import { createFileRoute } from "@tanstack/react-router";
import { PublicationsPage } from "@/components/dashboard/publications-page";

export const Route = createFileRoute("/publications")({
  head: () => ({
    meta: [
      { title: "Publications — Deuxda Admin" },
      { name: "description", content: "Review publications shared in the app." },
    ],
  }),
  component: () => <PublicationsPage />,
});
